module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hoFN9"))).then(() => parcelRequire('1iHdE'));